import { render, staticRenderFns } from "./ControlPhase.vue?vue&type=template&id=283ec449&"
import script from "./ControlPhase.vue?vue&type=script&lang=js&"
export * from "./ControlPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports